"use strict";
var ACC;
ACC.autocomplete = {

	_autoload: [
		"cacheElements",
		"bindSearchAutocomplete",
		"bindMobileSearchAutocomplete"
	],

	// Add your constants here.
	_constants: {
		ATTRIBUTE_DO_NOT_CLEAR: "data-donotclear",
		EVENT_CLOSE: "ACC.autocomplete.close",
		EVENT_OPEN: "ACC.autocomplete.open",
		SELECTOR_MOBILE_SEARCH_CLEAR: "#mobileSearch .internal-search .clear",
		SELECTOR_MOBILE_SEARCH_INPUT: "#mobileSearch .internal-search input",
		SELECTOR_SEARCH_CLEAR: ".searchContainer .internal-search .search-clear",
		SELECTOR_SEARCH_INPUT: ".searchContainer .internal-search .js-site-search-input",
		SELECTOR_SUBMIT_BUTTON: ".searchContainer .internal-search .header-submit-search-button"
	},

	// Populate on the fly for cached elements such as multiple use jQuery look-ups.
	_cache: {
		text: {}, // Populated on the fly to hold JSP text from properties.
		hasCategorySuggestions: false,
		hasSearchSuggestions: false
	},

	_searchLabels: window.searchBox || null,
	// Grab anything to cache immediately if always in use.
	cacheElements: function() {
		var AC = ACC.autocomplete;
		var cache = AC._cache;
		var c = AC._constants;

		cache.$mobileInput = $(c.SELECTOR_MOBILE_SEARCH_INPUT);
		cache.$mobileClear = $(c.SELECTOR_MOBILE_SEARCH_CLEAR);
		cache.$submitButton = $(c.SELECTOR_SUBMIT_BUTTON);
		cache.$searchClear = $(c.SELECTOR_SEARCH_CLEAR);
		cache.$searchInput = $(c.SELECTOR_SEARCH_INPUT);
	},

	bindSearchAutocomplete: function() {
		var AC = ACC.autocomplete;
		var cache = AC._cache;
		var c = AC._constants;

		// extend the default autocomplete widget, to solve issue on multiple instances of the searchbox component
		$.widget( "custom.yautocomplete", $.ui.autocomplete, {
			_create: function() {
				// get instance specific options form the html data attr
				var option = this.element.data("options");
				// set the options to the widget
				this._setOptions({
					minLength: option.minCharactersBeforeRequest,
					displayProductImages: option.displayProductImages,
					delay: option.waitTimeBeforeRequest,
					autocompleteUrl: option.autocompleteUrl,
					source: this.source
				});

				// Trigger event to show interaction.
				this._on( this.element, {
					keyup: function( event ) {
						this._trigger("userinput", event, {
							value: this.element.val()
						});
					}
				});

				// call the _super()
				$.ui.autocomplete.prototype._create.call(this);

			},
			close: function(e) {
				// This is a workaround for where on mobile devices, hiding the soft keyboard triggered the blur
				// event to be called immediately, which in turn closed the suggestions list before the user had
				// a chance to interact with them (scroll etc). This checks if the 'clear' button is still visible
				// on the field, if it is there is a high chance that the field is still in focus.
				// The above behaviour is OOTB for jquery autocomplete, the workaround is specific to how that
				// library works.
				if (ACC.autocomplete._cache.$mobileClear.is(':visible')) {
					return false;
				} else {
					// Trigger the parent close (OOTB behaviour)
					this._super(e);
				}
			},
			options: {
				cache: {}, // init cache per instance
				focus: function () { return false; }, // prevent textfield value replacement on item focus
				select: function (event, ui) {
					var uiProperties = ui.item;
					if (uiProperties !== null && uiProperties !== undefined) {
						// this div is only visible on mobile
						var mobileSearchDisplay = $("#mobileSearch").css("display");
						// this <li> is only visible on desktop
						var searchContainerDesktop = $(".searchContainer").css("display");
						switch(uiProperties.type) {
							case "autoSuggestion": {
								localStorage.setItem("searchTerm", uiProperties.value);
								localStorage.removeItem("searchCategorySuggestion");
								break;
							}
							case "categorySuggestion": {
								var inputValue;
								if (searchContainerDesktop === "none") {
									inputValue = $("#mbSearchbar").find("input[type=text]").val();
								} else {
									inputValue = $("#js-site-search-input").val();
								}
								localStorage.setItem("searchTerm", inputValue);
								localStorage.setItem("searchCategorySuggestion", uiProperties.value);
								break;
							}
							default: {
								break;
							}
						}
						window.location.href = uiProperties.url;
					}
				}
			},
			_renderItem: function (ul, item) {
				var regexp = new RegExp('(' + this.term + ')', 'gi'),
						classString = this.options.highlightClass ?  ' class="' + this.options.highlightClass + '"' : '',
						label = item.value.replace(regexp, '<span' + classString + '>$1</span>'),
						regexpCatSuggestion = new RegExp('(' + item.bannerName + ')', 'gi'),
						labelCatSuggestion = item.value.replace(regexpCatSuggestion, '<span' + classString + '>$1</span>');
				var renderHtml;

				var searchLabels = ACC.autocomplete && ACC.autocomplete.hasOwnProperty('_searchLabels') ? ACC.autocomplete._searchLabels : null;
				if (searchLabels) {
					var catTypeAheadTitle = '<h5 id="cat-type-ahead-title" aria-label="' + searchLabels['CATEGORY_SUGGESTION'] + '" class="ui-state-disabled">' + searchLabels['CATEGORY_SUGGESTION'] + '</h5>';
					var searchResultsTitle = '<h5 id="search-results-title" aria-label="' + searchLabels['SEARCH_SUGGESTION'] +'" class="ui-state-disabled">' + searchLabels['SEARCH_SUGGESTION'] + '</h5>';

					if (ACC.autocomplete._cache.hasCategorySuggestions && !$(ul).find('#cat-type-ahead-title').length) {
						ul.append(catTypeAheadTitle);
					}
					if (ACC.autocomplete._cache.hasSearchSuggestions && !$(ul).find('#search-results-title').length) {
						ul.append(searchResultsTitle);
					}
				}

				if (item.type === "autoSuggestion") {
					renderHtml = "<a href='"+ item.url + "' ><div class='name'>" + label + "</div></a>";
					return $("<li>")
							.data("item.autocomplete", item)
							.append(renderHtml)
							.appendTo(ul);
				}
				else if (item.type === "categorySuggestion") {
					var hasEntries = $(ul).find('.category-suggestion').length;
					var insertPos = $(ul).find('.ui-menu-item').last();

					if (hasEntries) {
						insertPos = $(ul).find('.category-suggestion').last();
					} else if ($(ul).find('#cat-type-ahead-title')) {
						insertPos = $(ul).find('#cat-type-ahead-title');
					}

					renderHtml = "<a href='"+ item.url + "' ><div class='name'>" + labelCatSuggestion + "</div></a>";
					return $("<li class='category-suggestion'>")
							.data("item.autocomplete", item)
							.append(renderHtml)
							.insertAfter(insertPos);
				}
				else if (item.type === "productResult") {
					renderHtml = "<a href='" + item.url + "' >";

					if (item.image != null){
						renderHtml += "<div class='thumb'><img src='" + item.image + "'  /></div>";
					}

					renderHtml += 	"<div class='name'>" + label +"</div>";
					renderHtml += 	"<div class='price'>" + item.price +"</div>";
					renderHtml += 	"</a>";

					return $("<li>").data("item.autocomplete", item).append(renderHtml).appendTo(ul);
				}
			},
			source: function (request, response) {
				var self = this;
				var term = request.term.toLowerCase();

				if (term in self.options.cache) {
					ACC.autocomplete._cache.hasSearchSuggestions = false;
					ACC.autocomplete._cache.hasCategorySuggestions = false;

					if (self.options.cache[term].find(function (el) { return el.type === "autoSuggestion"; })) {
						ACC.autocomplete._cache.hasSearchSuggestions = true;
					}
					if (self.options.cache[term].find(function (el) { return el.type === "categorySuggestion"; })) {
						ACC.autocomplete._cache.hasCategorySuggestions = true;
					}
					return response(self.options.cache[term]);
				}

				$.getJSON(self.options.autocompleteUrl, { term: request.term }, function (data) {
					var autoSearchData = [];
					if(data.suggestions != null) {
						ACC.autocomplete._cache.hasSearchSuggestions = false;
						if (data.suggestions.length) {
							ACC.autocomplete._cache.hasSearchSuggestions = true;
						}

						$.each(data.suggestions, function (i, obj)
						{
							autoSearchData.push({
								value: obj.term,
								url: ACC.config.encodedContextPath + "/search?st=" + obj.term,
								type: "autoSuggestion"
							});
						});
					}
					if (data.products != null) {
						$.each(data.products, function (i, obj) {
							autoSearchData.push({
								value: obj.name,
								code: obj.code,
								desc: obj.description,
								manufacturer: obj.manufacturer,
								url:  ACC.config.encodedContextPath + obj.url,
								price: obj.price.formattedValue,
								type: "productResult",
								image: (obj.images!=null && self.options.displayProductImages) ? obj.images[0].url : null // prevent errors if obj.images = null
							});
						});
					}

					if (data.categories != null) {
						ACC.autocomplete._cache.hasCategorySuggestions = false;
						if (data.categories.length) {
							ACC.autocomplete._cache.hasCategorySuggestions = true;
						}

						$.each(data.categories, function(index, catObj) {
							if (catObj.suggestedCategories) {
								$.each(catObj.suggestedCategories, function(i, obj) {
									autoSearchData.push({
										bannerName: obj.bannerName,
										value:  obj.bannerName + ' in ' + catObj.parentCategoryName,
										url:  ACC.config.encodedContextPath + obj.url,
										type: "categorySuggestion"
									});
								});
							}
						});
					}
					self.options.cache[term] = autoSearchData;
					return response(autoSearchData);
				});
			}
		});

		// Pt.1 CLEAR WORKAROUND:
		// Due to race condition with requirement to clear the search input on yautocomplete close,
		// but also prevent empty submits (so submit event looking for value), having to implement
		// a workaround to prevent yautocomplete code clearing search input value if it thinks a
		// click of the submit button triggered the yautocomplete blur event.
		cache.$submitButton.on("mouseover", function() {
			cache.$searchInput.attr(c.ATTRIBUTE_DO_NOT_CLEAR, 'true');
		});

		cache.$submitButton.on("mouseout", function() {
			cache.$searchInput.removeAttr(c.ATTRIBUTE_DO_NOT_CLEAR);
		});


		// Create and configure yautocomplete component.
		if (cache.$searchInput.length > 0) {
			cache.$searchInput.yautocomplete({
				highlightClass: 'item-highlight',
				close: function (event, ui) {
					cache.$searchClear.hide();
				}
			});

			cache.$searchClear.on("click", function() {
				cache.$searchInput.trigger("yautocompleteclose");
			});
		}

		// Quickfix to stop the search-mask element opening on resize from mobile to larger screen.
		$(window).on("resize", function() {
			$(".search-mask").fadeOut('fast');
		});
	},

	bindMobileSearchAutocomplete: function() {
		var AC = ACC.autocomplete;
		var cache = AC._cache;

		if (cache.$mobileInput.length) {
			cache.$mobileInput.yautocomplete({
				appendTo: "#mobileSearchAutocomplete",
				highlightClass: 'keyword'
			});

			// Clearing the input closes the autocomplete results.
			cache.$mobileClear.on("click", function () {
				AC.mobileSearchClose();
			});

			cache.$mobileInput.on("keyup input", function () {
				if (this.value != "") {
					AC.mobileSearchOpen();
				}
				else {
					AC.mobileSearchClose();
				}
			});
		}
	},

	mobileSearchClose: function() {
		var AC = ACC.autocomplete;
		var cache = AC._cache;
		var c = AC._constants;
		cache.$mobileClear.hide();
		cache.$mobileInput.val("");
		$(document).trigger(c.EVENT_CLOSE);
		$('#mobileSearchAutocompleteKey').addClass('hide');
		$('.ui-autocomplete').hide();
	},

	mobileSearchOpen: function () {
		var AC = ACC.autocomplete;
		var cache = AC._cache;
		var c = AC._constants;
		var searchInput = $('form[name=mobile_TjxSearchBox] input').val();
		cache.$mobileClear.show();
		$(document).trigger(c.EVENT_OPEN);

		$('#mobileSearchAutocompleteKey').removeClass('hide');
		$('#searchKey').text(searchInput);
	}

};
